export class RejectReason {
  id: number;
  description: string;
  neg:string;
  constructor(id: number, description: string, neg:string) {
    this.id = id;
    this.description = description;
    this.neg=neg
  }
}